import React from 'react';
import PropTypes from 'prop-types';
import useDocumentFirestore from '@web/hooks/useDocumentFirestore';
import {Button} from 'antd';
import {UserContext} from '@web/hooks/context';
import {api} from '@web/lib/api';
import {notifyAndTrack} from './notification';
import {ProgressBar} from './ProgressBar';

AppInstallButton.propTypes = {
  listingPath: PropTypes.string.isRequired,
};

function AppInstallButton(props) {
  const [userId] = React.useContext(UserContext);
  const [app, loadingApp] = useDocumentFirestore(["user", userId, "apps", props.listingPath.split("/").pop()].join("/"));
  const [processing, setProcessing] = React.useState(false);

  const onClickInstall = () => {
    setProcessing(true);
    api.LINE("/app/install", {
      listingPath: props.listingPath,
    })
    .then((res) => {
      if (!res.success) {
        console.error("Error installing app", res);
        return notifyAndTrack.error(res.message);
      }
      notifyAndTrack.success("App installed", "", {
        message: "App installed",
        description: "The app is now installed and ready to use.",
      });
    })
    .finally(() => {
      setProcessing(false);
    });
  }

  const onClickRemove = () => {
    setProcessing(true);
    api.LINE("/app/uninstall", {
      listingPath: props.listingPath,
    })
    .then((res) => {
      if (!res.success) {
        console.error("Error removing app", res);
        return notifyAndTrack.error(res.message);
      }
      notifyAndTrack.success("App removed", "", {
        message: "App removed",
        description: "The app is now removed.",
      });
    })
    .finally(() => {
      setProcessing(false);
    });
  }

  if (loadingApp) {
    return null;
  }

  return !app ?
    <div className="space space-center-y">
      <Button onClick={onClickInstall} shape="round" className="icon-btn green-color">{processing ? <ProgressBar visible loop /> : "install"}</Button>
    </div> :
    <div className="space space-center-y">
      <Button onClick={onClickRemove} shape="round" className="icon-btn orange-color">{processing ? <ProgressBar visible loop /> : "remove"}</Button>
    </div>
}

export default AppInstallButton;
